/* @jsx h */
import { defineComponent, h } from "vue";
import { RouterLink } from "vue-router";

export type AttentionItem = {
  icon: string;
  tone: "error" | "warning" | "info";
  text: string;
  to: string;
  action: string;
};

const TONE: Record<AttentionItem["tone"], string> = {
  error: "bg-error/10 text-error",
  warning: "bg-warning/15 text-warning",
  info: "bg-info/10 text-info",
};

type Props = { items: AttentionItem[]; emptyText: string };

// "Needs attention" on an overview page: one linked row per thing to do, or
// an all-clear message.
export const AttentionItems = defineComponent<Props>({
  name: "AttentionItems",
  props: ["items", "emptyText"],
  setup(props) {
    return () => {
      if (!props.items.length) {
        return (
          <div class="flex items-center gap-3 rounded-lg bg-success/10 p-4 text-sm">
            <span class="material-symbols-outlined text-success">task_alt</span>
            {props.emptyText}
          </div>
        );
      }
      return (
        <ul class="divide-y divide-base-200">
          {props.items.map((item) => (
            <li key={item.text}>
              <RouterLink to={item.to} class="flex items-center gap-3 py-2.5 hover:bg-base-200/50">
                <span class={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full ${TONE[item.tone]}`}>
                  <span class="material-symbols-outlined text-lg">{item.icon}</span>
                </span>
                <span class="flex-1 text-sm text-accent">{item.text}</span>
                <span class="whitespace-nowrap text-xs font-medium text-primary">{item.action} →</span>
              </RouterLink>
            </li>
          ))}
        </ul>
      );
    };
  },
});
